import { render, staticRenderFns } from "./Bible.vue?vue&type=template&id=26e9975e&scoped=true&"
import script from "./Bible.vue?vue&type=script&lang=js&"
export * from "./Bible.vue?vue&type=script&lang=js&"
import style0 from "./Bible.vue?vue&type=style&index=0&id=26e9975e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e9975e",
  null
  
)

export default component.exports